import React, {useEffect, useRef} from "react";
import { Help } from "player-components";
import Faqs from "../../components/faqs";
import { selectClientConfig } from "../../features/ui/uiSlice";
import { useDispatch, useSelector } from "react-redux";
import { selectMediaSessionStarted, selectPlaybackState, selectSession, setMediaSessionStarted} from "../../features/session/sessionSlice";

// pgw 30-sep-2025 - replace all debugging debugLog calls with debugLog
import { debugLog } from '../../debugLog';


const MediaSession = () => {
    const dispatch = useDispatch();
    const playbackState = useSelector(selectPlaybackState);
    const session = useSelector(selectSession);
    const mediaSessionStarted = useSelector(selectMediaSessionStarted);

    const clientConfig = useSelector(selectClientConfig);

    const play = () => {

    }

    const pause = () => {

    }

    const stop = () => {

    }

    const startMediaSession = () => {

		// Is there ever called ??
		debugLog("pgw pgw2_5 startMediaSession p1.1")

		/*
        if ('audioSession' in navigator) {
			debugLog("pgw pgw2_5 p3, navigator.audioSession = ", navigator.audioSession)

			debugLog("pgw pgw2_5 p4, navigator.audioSession.type = ", navigator.audioSession.type)
			navigator.audioSession.type = 'playback';
			debugLog("pgw pgw2_5 p5, navigator.audioSession.type = ", navigator.audioSession.type)

        }
		else {
			debugLog("pgw pgw2_5 p5a, navigator.audioSession not defined navigator.audioSession = ", navigator.audioSession)

			debugLog("pgw pgw2_5 p6a, navigator.audioSession.type = ", navigator.audioSession.type)
			navigator.audioSession.type = 'playback';
			debugLog("pgw pgw2_5 p7a, navigator.audioSession.type = ", navigator.audioSession.type)

		}
		*/


        navigator.mediaSession.setActionHandler('play', play);
        navigator.mediaSession.setActionHandler('pause', pause);
        navigator.mediaSession.setActionHandler('stop', stop);
        
        dispatch(setMediaSessionStarted(true));
    }

    useEffect(()=>{
        if (session?.song) {
            if ('mediaSession' in navigator) {
                if (!mediaSessionStarted) startMediaSession();

				// pgw 22-apr-2023
				// Remove redundant artwork
                navigator.mediaSession.metadata = new MediaMetadata({
                    title: session.song.mix,
                    artist: session.song.artist,
                    album: clientConfig.labels.appTitle
/*
                    album: clientConfig.labels.appTitle,
                    artwork: [
                      { src: clientConfig.images.albumArt, sizes: '512x512', type: 'image/png' },
                    ]
*/
                });
            }
        }
    }, [session]);

    useEffect(()=>{

		// Is there ever called ??
		debugLog("pgw pgw2_5 p1")
        if ('mediaSession' in navigator) {
			debugLog("pgw pgw2_5 p2, navigator.mediaSession.playbackState = ", navigator.mediaSession.playbackState)
			debugLog("pgw pgw2_5 p2, playbackState = ", playbackState)
            if (playbackState === 'playing') {
                navigator.mediaSession.playbackState = "playing";
            } else {
                navigator.mediaSession.playbackState = "paused";
            }

        }
        
		
        if ('audioSession' in navigator) {
			debugLog("pgw pgw2_5 p3, navigator.audioSession = ", navigator.audioSession)

			debugLog("pgw pgw2_5 p4, navigator.audioSession.type = ", navigator.audioSession.type)
			navigator.audioSession.type = 'playback';
			debugLog("pgw pgw2_5 p5, navigator.audioSession.type = ", navigator.audioSession.type)

        }
		else {
			debugLog("pgw pgw2_5 p5, navigator.audioSession not defned navigator.audioSession = ", navigator.audioSession)
		}
		/**/



    }, [playbackState])


  return null;
};
export default MediaSession;
